import { useGetUserDetails } from '@festina-life/authentication'
import { CircularSpinner, Tooltip } from '@festina-life/ui/feedback'
import { Icon } from '@festina-life/ui/structure'

type Props = {
  userId: string
  showIcon: boolean
}

export const UserName = ({ userId, showIcon }: Props) => {
  const {
    data: userDetails,
    error,
    isLoading,
  } = useGetUserDetails({
    userId,
  })

  const userName = userDetails?.displayName
  const userNameNotFound = error || !userName

  if (isLoading) {
    return <CircularSpinner className="size-5" />
  }

  if (userNameNotFound) {
    return showIcon ? (
      <Tooltip tip={userId}>
        <Icon name="ComputerDesktop" size="md" />
      </Tooltip>
    ) : (
      userId
    )
  }

  return userName
}
